var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workbench-body"},[_c('apiScriptView-com',{attrs:{"work":_vm.work},on:{"updateApiName":_vm.updateApiName,"handleismodifyByOldTab":_vm.handleismodifyByOldTab,"getSourceId":_vm.getSourceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }